module.exports = __webpack_public_path__ + "img/planet-saturn-geology.aa61a7dc.png";